module.exports = __webpack_public_path__ + "img/teamskill.9425bf8a.svg";